import { inject } from '@angular/core';
import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpContextToken } from '@angular/common/http';
import { switchMap } from 'rxjs';
import { from } from 'rxjs';
import { AuthService } from './auth.service';
import { APP_SETTINGS } from './runtime-settings';

// HttpContextToken for singleton context
export const IS_SINGLETON = new HttpContextToken<boolean>(() => false);

// Functional HTTP interceptor for attaching the JWT token to /api requests
export const tokenInterceptor: HttpInterceptorFn = (
    request: HttpRequest<unknown>,
    next: HttpHandlerFn
) => {
    const authService = inject(AuthService);
    const { securedUrls } = inject(APP_SETTINGS);
    if (securedUrls.some(securedUrl=>request.url.indexOf(securedUrl) === 0)) {
        return from(authService.getToken()).pipe(
            switchMap(token => {
                const isSingleton = request.context.get(IS_SINGLETON);
                const setHeaders: Record<string, string> = {};

                // add authorization header with jwt token if available
                if (token && request.url.indexOf('/rpc/auth/login') === -1 && request.url.indexOf('/rpc/auth/refresh_token') === -1) {
                    setHeaders['Authorization'] = `Bearer ${token}`;
                }

                if (['GET','HEAD'].includes(request.method)) {
                    setHeaders['Accept-Profile'] = 'api_mobile';
                }

                if (['POST','PUT','PATCH','DELETE'].includes(request.method)) {
                    setHeaders['Content-Profile'] = 'api_mobile';
                }

                // add accept header for singleton context
                if (request.method === 'GET' && isSingleton) {
                    setHeaders['Accept'] = 'application/vnd.pgrst.object+json';
                }

                if (Object.keys(setHeaders).length > 0) {
                    request = request.clone({ setHeaders });
                }

                return next(request);
            })
        );
    } else {
        return next(request)
    }
};
